$(document).on('turbo:load turbo:render', () => {
    let toggleElement = $('.radio-toggle');
    if (toggleElement.length) {
        toggleElement.each((i, item) => {
          let $checkboxes = $(item).find('input[type="checkbox"]');
          if ($checkboxes.length == 2) {
            let $checkbox1 = $($checkboxes[0]);
            let $checkbox2 = $($checkboxes[1]);
            $checkbox1.on('click', () => {
              if ($checkbox2.is(':checked')) {
                $checkbox2.prop('checked', false);
              }
            });
            $checkbox2.on('click', () => {
              if ($checkbox1.is(':checked')) {
                $checkbox1.prop('checked', false);
              }
            })
          }
        });
    }
});